import { getRuntimeConfig } from 'lib/runtimeConfig';

const DEFAULT_LOCALE = 'en';

const LOCALES = {
  bdo: 'en',
};

export const getDefaultLocale = () => LOCALES[getRuntimeConfig().whitelabel.WL_NAME] || DEFAULT_LOCALE;
